module.exports = __webpack_public_path__ + "media/1fie-c-nes.c651d7ee.mp3";